var router = require('pjax').Router;
var manageEntryView = require('./manage-entry-view.js');
var index = require('./index.js');
var feedback = require('./feedback.js');
var manageEntries = require('./manage-entries.js');
var manageDuplicates = require('./manage-duplicates.js');
var reviewEntries = require('./review-entries.js');
var preview = require('./preview.js');
var contract = require('./contract.js');

router.get('entry/manager/([a-zA-Z]+)', manageEntryView);
router.get('entry/manager/:any/preview', preview);
router.get('entry/entrant', index);
router.get('entry/entrant/:any/preview', preview);
router.get('entry/manager', manageEntries);
router.get('entry/feedback/:any', feedback);
router.get('entry/review', reviewEntries);
router.get('entry/duplicates/manage', manageDuplicates);
router.get('entry/entrant/:any/contract/:any', contract);
